import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PlatformConsumerEnvironmentAPIType } from '@wix/editor-platform-environment-api';
import { WorkerHostEndpoint } from '@wix/editor-platform-transport';
import { createEditorPlatformWorkerError, EditorPlatformWorkerErrorCode } from '../../errors';
import { EnvType } from '@wix/editor-platform-private-api';
let callbackId = 0;
export class PlatformWorkerStrategy {
  constructor(limitedPrivateAPI, events) {
    this.limitedPrivateAPI = limitedPrivateAPI;
    this.events = events;
    _defineProperty(this, "essentials", void 0);
    _defineProperty(this, "workerEventCallbacks", []);
    _defineProperty(this, "strategy", void 0);
    _defineProperty(this, "state", {});
    this.strategy = this.constructor.name;
  }
  updateWorkerState() {
    this.state[this.strategy] = (this.state[this.strategy] || 0) + 1;
  }
  generateWorkerId() {
    return `${this.strategy}_${this.state[this.strategy]}`;
  }
  buildPrivateAPI(config) {
    return this.limitedPrivateAPI.build({
      env: EnvType.Worker,
      type: config.type
    });
  }
  async spawnWorker(url) {
    var _this$events;
    this.updateWorkerState();
    const spawnWorkerEvent = (_this$events = this.events) == null ? void 0 : _this$events.factories.createWorkerSpawnEvent({
      url,
      workerId: this.generateWorkerId(),
      strategy: this.strategy
    });
    return this.events.withEvent(spawnWorkerEvent, async () => {
      try {
        const worker = new Worker(url);
        return new Promise((resolve, reject) => {
          WorkerHostEndpoint.connect(worker, async transport => {
            try {
              const workerApi = await transport.waitAPI(PlatformConsumerEnvironmentAPIType.Worker);
              await workerApi.initEnvironment({
                buildPrivateAPI: this.buildPrivateAPI.bind(this)
              });
              await workerApi.subscribe(event => {
                this.workerEventCallbacks.forEach(_ref => {
                  let {
                    fn
                  } = _ref;
                  fn(event);
                });
              });
              resolve(workerApi);
            } catch (e) {
              reject(e);
            }
          });
        });
      } catch (e) {
        throw createEditorPlatformWorkerError(EditorPlatformWorkerErrorCode.WorkerInitError).withParentError(e).withUrl(url);
      }
    });
  }
  onWorkerEvent(cb) {
    const _callbackId = ++callbackId;
    this.workerEventCallbacks.push({
      id: _callbackId,
      fn: cb
    });
    return () => {
      this.workerEventCallbacks = this.workerEventCallbacks.filter(_ref2 => {
        let {
          id
        } = _ref2;
        return id !== _callbackId;
      });
    };
  }
}
//# sourceMappingURL=PlatformWorkerStrategy.js.map